<!-- 
	描述：托管代收详情页
	编辑于     2022-5-30 09:22:11
	编辑人     钱磊
-->
<template>
	<div class="filed-info-layout h100">
		<div class="common-top" ref="formRef">
			<el-row>
				<el-col :span="24">
					<h5>托管代收、代付合计：</h5>
				</el-col>
			</el-row>
			<div class="total-table">
				<vxe-table ref="totalTable" :data="totalData" size="small" highlight-current-row border>
					<vxe-table-column width="20%" field="amount" title="代收总金额" align="center"></vxe-table-column>
					<vxe-table-column width="20%" field="payedAmount" title="已代付总金额" align="center"></vxe-table-column>
					<vxe-table-column width="20%" field="unpayTotalAmount" title="未代付总金额" align="center"></vxe-table-column>
					<vxe-table-column width="20%" field="refundAmount" title="退款总额" align="center"></vxe-table-column>
					<vxe-table-column width="20%" field="surplusAmount" title="剩余金额" align="center"></vxe-table-column>
				</vxe-table>
			</div>
			<el-divider></el-divider>
			<!-- 托管代收订单信息详情 -->
			<el-row>
				<el-col :span="24">
					<h5>托管代收订单信息：</h5>
				</el-col>
			</el-row>
			<div class="agent-detail ml20 mt20">
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管代收订单号：</span>
						<span>{{ detailInfo.bizOrderNo }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>通商云订单号：</span>
						<span>{{ detailInfo.orderNo }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管金额：</span>
						<span class="color-blue">{{ detailInfo.amount }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>托管状态：</span>
						<span :class="dealStatus(detailInfo.payStatus).class">{{ dealStatus(detailInfo.payStatus).text }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管人名称：</span>
						<span>{{ detailInfo.payer }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>托管人类型：</span>
						<span>{{ detailInfo.payerType === 0 ? '个人' : '企业' }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管人证件类型：</span>
						<span>{{ detailInfo.cardType === 0 ? '身份证' : '营业执照' }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>托管人证件号码：</span>
						<span>{{ detailInfo.cardNo }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管人（会员ID）：</span>
						<span>{{ detailInfo.bizUserid }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>手续费：</span>
						<span>{{ detailInfo.fee }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>支付方式：</span>
						<span>{{ detailInfo.payMethodName }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>支付人账户（托管方）：</span>
						<span>{{ detailInfo.acct }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>访问终端类型：</span>
						<span>{{ detailInfo.source === 1 ? '移动端' : 'pc端' }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>摘要：</span>
						<span>{{ detailInfo.summary }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>行业代码：</span>
						<span>{{ detailInfo.industryCode }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>行业名称：</span>
						<span>{{ detailInfo.industryName }}</span>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mb10">
					<el-col :span="9" class="text-overflow">
						<span>托管日期：</span>
						<span>{{ detailInfo.createDate }}</span>
					</el-col>
					<el-col :span="9" class="text-overflow">
						<span>订单过期日期：</span>
						<span>{{ detailInfo.orderExpireDate }}</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" class="mt20">
						<span>收款人列表：</span>
					</el-col>
				</el-row>
				<div class="payee-table mt20">
					<vxe-table ref="payeeTable" :data="payeeData" size="small" highlight-current-row border resizable>
						<vxe-table-column field="bizUserid" title="收款人（会员ID）" align="center" min-width="180px"></vxe-table-column>
						<vxe-table-column field="payeeType" title="收款人类型" align="center" width="130px">
							<template #default="{ row }">
								{{ row.payeeType === 0 ? '个人' : '企业' }}
							</template>
						</vxe-table-column>
						<vxe-table-column field="payee" title="收款人名称" align="center" min-width="160px"></vxe-table-column>
						<vxe-table-column field="cardType" title="收款人证件类型" align="center" width="130px">
							<template #default="{ row }">
								{{ row.cardType === 0 ? '身份证' : '营业执照' }}
							</template>
						</vxe-table-column>
						<vxe-table-column field="cardNo" title="收款人证件号" align="center" min-width="180px"></vxe-table-column>
						<vxe-table-column field="amount" title="代付金额" align="center" width="120px"></vxe-table-column>
						<vxe-table-column field="payedAmount" title="已代付金额" align="center" width="120px"></vxe-table-column>
						<vxe-table-column field="unpayAmount" title="未代付金额" align="center" width="120px"></vxe-table-column>
					</vxe-table>
				</div>
			</div>
			<el-divider></el-divider>
			<!-- 托管代付订单信息表格 -->
			<div class="payment-order">
				<div>
					<span class="bold-text">托管代付订单信息：</span>
					<template v-if="parseInt(detailInfo.payStatus) > 2">
						<span>(源托管代收订单号：</span>
						<span>{{ detailInfo.bizOrderNo }})</span>
					</template>
				</div>
				<el-row class="mt20 ml20">
					<el-col :span="24">
						<vxe-table ref="paymentTable" :data="paymentData" size="small" highlight-current-row border v-if="paymentData.length">
							<vxe-table-column field="bizOrderNo" title="代付订单号" align="center" width="200px"></vxe-table-column>
							<vxe-table-column field="createDate" title="代付日期" align="center" width="200px"></vxe-table-column>
							<vxe-table-column field="orderNo" title="通商云订单号" align="center" width="160px"></vxe-table-column>
							<vxe-table-column field="amount" title="代付金额" align="center" width="100px"></vxe-table-column>
							<vxe-table-column field="fee" title="代付手续费" align="center" width="90px"></vxe-table-column>
							<vxe-table-column field="bizUserid" title="收款人(会员ID)" align="center" width="170px"></vxe-table-column>
							<vxe-table-column field="payee" title="收款人名称" align="center" min-width="110px"></vxe-table-column>
							<vxe-table-column field="cardType" title="收款人证件类型" align="center" width="130px">
								<template #default="{ row }">
									{{ row.cardType === 0 ? '身份证' : '营业执照' }}
								</template>
							</vxe-table-column>
							<vxe-table-column field="cardNo" title="收款人证件号" align="center" width="180px"></vxe-table-column>
							<vxe-table-column field="payStatus" title="代付状态" align="center" width="90px">
								<template #default="{ row }">
									<span>{{ statusName(row.payStatus) }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" align="center" width="110px">
								<template #default="{ row }">
									<el-button round plain class="table-btn" type="primary" size="small" @click="showDetail(row, 'payment')">
										<svg-icon icon-class="form-details"></svg-icon> 代付详情
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
						<div v-else>
							<el-empty description="暂无代付" :image-size="40"></el-empty>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<!-- 退款信息 -->
			<div class="payment-order">
				<div>
					<span class="bold-text">退款信息：</span>
					<template v-if="parseInt(detailInfo.payStatus) > 2">
						<span>(源托管代收订单号：</span>
						<span>{{ detailInfo.bizOrderNo }})</span>
					</template>
				</div>
				<el-row class="mt20 ml20">
					<el-col :span="24">
						<vxe-table ref="refundTable" :data="refundData" size="small" highlight-current-row border v-if="refundData.length">
							<vxe-table-column field="bizOrderNo" title="退款订单号" align="center" width="200px"></vxe-table-column>
							<vxe-table-column field="createDate" title="退款日期" align="center" width="150px"></vxe-table-column>
							<vxe-table-column field="orderNo" title="通商云订单号" align="center" width="200px"></vxe-table-column>
							<vxe-table-column field="amount" title="退款金额" align="center" width="100px"></vxe-table-column>
							<vxe-table-column field="feeAmount" title="退款手续费" align="center" width="90px"></vxe-table-column>
							<vxe-table-column field="bizUserid" title="托管人(会员ID)" align="center" width="170px"></vxe-table-column>
							<vxe-table-column field="payer" title="托管人名称" align="center" min-width="110px"></vxe-table-column>
							<vxe-table-column field="cardType" title="托管人证件类型" align="center" width="130px">
								<template #default="{ row }">
									{{ row.cardType === 0 ? '身份证' : '营业执照' }}
								</template>
							</vxe-table-column>
							<vxe-table-column field="cardNo" title="托管人证件号" align="center" width="180px"></vxe-table-column>
							<vxe-table-column field="payStatus" title="退款状态" align="center" width="90px">
								<template #default="{ row }">
									<span>{{ statusName(row.payStatus) }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" align="center" width="110px">
								<template #default="{ row }">
									<el-button round plain class="table-btn" type="primary" size="small" @click="showDetail(row, 'refund')">
										<svg-icon icon-class="form-details"></svg-icon> 退款详情
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
						<div v-else>
							<el-empty description="暂无退款" :image-size="40"></el-empty>
						</div>
					</el-col>
				</el-row>
			</div>
			<!-- 查看详情服务 -->
			<el-dialog :title="viewObj.title" :visible.sync="viewObj.show" :width="viewObj.width" append-to-body center :close-on-click-modal="false" @close="closeDialog">
				<div class="dialog-check">
					<!-- 托管代收订单基本信息详情 -->
					<div class="order-detail">
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>源托管代收订单号：</span>
								<span>{{ viewObj.rowData.oldOrderNo }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>托管日期：</span>
								<span>{{ viewObj.rowData.collectDate }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>托管人名称：</span>
								<span>{{ viewObj.rowData.payer }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>托管人(会员ID)：</span>
								<span>{{ viewObj.rowData.bizUserid }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>托管人证件类型：</span>
								<span>{{ viewObj.rowData.cardType === 0 ? '身份证' : '营业执照' }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>托管人证件号：</span>
								<span>{{ viewObj.rowData.cardNo }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>托管金额：</span>
								<span>{{ viewObj.rowData.collectAmount }} 元</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>剩余代付金额：</span>
								<span>{{ viewObj.rowData.surplusAmount }} 元</span>
							</el-col>
						</el-row>
					</div>
					<el-divider></el-divider>
					<!-- 代付信息详情 -->
					<div class="payment-detail" v-if="viewObj.mode == 'payment'">
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>代付订单号：</span>
								<span>{{ viewObj.rowData.bizOrderNo }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>通商云订单号：</span>
								<span>{{ viewObj.rowData.orderNo }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>代付总金额：</span>
								<span>{{ viewObj.rowData.amount }} 元</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>代付状态：</span>
								<span>{{ statusName(viewObj.rowData.payStatus) }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>业务码：</span>
								<span>{{ viewObj.rowData.tradeCode }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>代付去向：</span>
								<span></span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="24" class="text-overflow">
								<span>分账明细：</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="24">
								<vxe-table ref="paymentDetail" :data="paymentDetailData" size="small" resizable highlight-current-row border>
									<vxe-table-column field="bizUserid" title="收款人(会员ID)" align="center" width="170px"></vxe-table-column>
									<vxe-table-column field="accountSetNo" title="收款人账户集编号" align="center" width="135px"></vxe-table-column>
									<vxe-table-column field="amount" title="代付金额" align="center" width="110px"></vxe-table-column>
									<vxe-table-column field="fee" title="代付手续费" align="center" width="100px"></vxe-table-column>
									<vxe-table-column field="payee" title="收款人名称" align="center" width="min-120px"></vxe-table-column>
									<vxe-table-column field="cardType" title="收款人证件类型" align="center" width="120px">
										<template #default="{ row }">
											{{ row.cardType === 0 ? '身份证' : '营业执照' }}
										</template>
									</vxe-table-column>
									<vxe-table-column field="cardNo" title="收款人证件号" align="center" width="180px"></vxe-table-column>
								</vxe-table>
							</el-col>
						</el-row>
					</div>
					<!-- 退款信息详情 -->
					<div class="refund-detail" v-else>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>退款流水号：</span>
								<span>{{ viewObj.rowData.bizOrderNo }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>通商云订单号：</span>
								<span>{{ viewObj.rowData.orderNo }}</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>退款金额：</span>
								<span>{{ viewObj.rowData.amount }} 元</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>退款手续费：</span>
								<span>{{ viewObj.rowData.fee }} 元</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>退款方式：</span>
								<span>{{ viewObj.rowData.refundType }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>退款方式：</span>
								<span>全额退款</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="10" class="text-overflow">
								<span>退款状态：</span>
								<span>{{ statusName(viewObj.rowData.payStatus) }}</span>
							</el-col>
							<el-col :span="10" :offset="4" class="text-overflow">
								<span>实际退款金额：</span>
								<span>{{ viewObj.rowData.finalAmount }} 元</span>
							</el-col>
						</el-row>
						<el-row class="mb10">
							<el-col :span="24" class="text-overflow">
								<span>退款日期：</span>
								<span>{{ viewObj.rowData.refundDate }}</span>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

import { getCollectDetail, escrowInfo, refundInfo } from "api/modules/paymentSettlement";
export default {
	data() {
		return {
			totalData: [], //托管代收、代付合计
			detailInfo: {}, //托管代收订单信息
			payeeData: [], //收款人列表
			paymentData: [], //托管代付订单信息
			refundData: [{ type: 1 }, { type: 2 }], //退款信息
			viewObj: {
				show: false,
				title: "代付详情",
				width: "1000px",
				rowData: {},
				mode: "",
			},
			paymentDetailData: [], //分账明细
		};
	},
	created() {
		if (this.$getSessionItem('agentDetailId')) {
			this.getDetail(this.$getSessionItem('agentDetailId'))
		}
	},
	methods: {
		// 获取详情数据
		getDetail(rowId) {
			getCollectDetail({id: rowId})
				.then(res => {
					// 第一块表格 托管代收、代付合计：
					let arr = []
					let obj = {
						amount: res.data.collectBill.amount,	// 代收金额
						payedAmount: res.data.collectBill.payedAmount,		// 已代付金额
						surplusAmount: res.data.collectBill.surplusAmount,		// 已代付金额
						refundAmount: res.data.collectBill.refundAmount,		// 已代付金额
						unpayTotalAmount: res.data.collectBill.unpayTotalAmount,		// 已代付金额
					}
					arr.push(obj)
					this.$set(this, 'totalData', arr)

					// 第二块 表单 + 表格： 托管代收订单信息
					this.detailInfo = res.data.collectBill
					this.payeeData = res.data.payees

					// 第三块：托管代付列表
					this.paymentData = res.data.escrowBills

					// 第三块：退款列表
					this.refundData = res.data.refundBills
				})
		},

		// 处理资金托管状态
		dealStatus(status) {
			let obj = {
				0: {
					text: '待托管',
					class: 'color-warning'
				},
				1: {
					text: '托管中',
					class: 'color-success'
				},
				2: {
					text: '托管失败',
					class: 'color-red'
				},
				3: {
					text: '部分已代付',
					class: 'color-warning'
				},
				4: {
					text: '全部已代付',
					class: 'color-success'
				},
				5: {
					text: '全部退款',
					class: 'color-success'
				}
			}
			let key = status ? parseInt(status) : 0
			return obj[key]
		},

		// 处理代付、退款状态
		statusName(status) {
			let name = ''
			switch (parseInt(status)) {
				case 0:
					name = '进行中'
					break
				case 1:
					name = '成功'
					break
				case 2:
					name = '失败'
					break
				default:
					break
			}
			return name
		},

		// 列表详情
		showDetail(row, type) {
			// this.viewObj.rowData = row;

			this.showMoreDetails(row, type)
			switch (type) {
				case "payment":
					this.viewObj.show = true;
					this.viewObj.title = "代付详情";
					this.viewObj.mode = "payment";
					return;
				default:
					this.viewObj.show = true;
					this.viewObj.title = "退款详情";
					this.viewObj.mode = "refund";
			}
		},

		// 详情页接口
		showMoreDetails(row, type) {
			let params = {
				id: row.id,
				billId: row.billId
			}

			if (type === 'payment') {
				params.listId = row.listId
				escrowInfo(params)
					.then(res => {
						this.viewObj.rowData = res.data
						this.paymentDetailData = res.data.splitDetails || []
					})
					.catch(err => {})
			} else {
				refundInfo(params)
					.then(res => {
						this.viewObj.rowData = res.data
					})
			}
		},
		// 关闭查看申请服务的弹框
		closeDialog() {
			this.viewObj.title = "";
			this.viewObj.show = false;
			this.viewObj.mode = "";
			this.viewObj.rowData = {};
		},
	},
	computed: {},
};

</script>

<style lang='less' scoped>
.filed-info-layout {
	height: 100% !important;
	background-color: #fff;

	.common-top {
		height: 100%;
		padding: 20px;

		.el-form-item {
			margin-bottom: 0;
		}

		.total-table {
			margin: 20px 0 0 20px;
		}

		.agent-detail {
			span {
				font-size: 14px;
			}
		}

		.payment-order {
			span {
				font-size: 14px;
			}

			.bold-text {
				font-weight: bold;
			}
		}
	}
}

</style>
